import { render } from "./DropdownTitle.vue?vue&type=template&id=4f6a0695"
import script from "./DropdownTitle.vue?vue&type=script&lang=js"
export * from "./DropdownTitle.vue?vue&type=script&lang=js"

import exportComponent from "/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__